// Monaco loads syntax/highlighter/etc. as Web Workers and uses MonacoEnvironment.getWorker to
// resolve worker URLs. Vite bundles workers via `?worker` imports; we point Monaco at the
// bundled editor worker. We only need the editor worker because language services come from
// the WASM bridge, not Monaco's bundled TS/JSON/CSS/HTML workers.
//
// Import this module for side effects BEFORE any other Monaco import resolves. In chorus
// that means: main.ts does `import './planning/lib/monaco-workers'` immediately after Vue
// imports and before any planning-editor code runs.

import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker'

self.MonacoEnvironment = {
  getWorker() {
    return new EditorWorker()
  }
}
